import { CERTIFICATE_MODULE } from "@/api_framework/api_config";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback } from "react";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { setLoading } from "@/app_redux/reducers/loading_reducer";
import { ICertificatesDocumentListResponse } from "@/api_framework/api_modals/Certificates";
import { setDocumentList } from "@/app_redux/reducers/slices/auth/certificate_slice";
import { useAPIUtils } from "../../useAPIUtils";

AxiosCurlirize(axios, () => {});

export const useDocumentListAPI = () => {
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const configuration = useConfiguration();
  const { captureError } = useAPIUtils();

  const execute = useCallback(
    async (userId: string) => {
      dispatch(
        setLoading({
          key: "isCouponServiceListInProgress",
          status: true,
        }),
      );
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        await axios
          .get(`${CERTIFICATE_MODULE?.DOCUMENT_LIST?.baseURL}?customer_id=${userId}`, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<ICertificatesDocumentListResponse>) => {
            if (res.data.status) {
              dispatch(setDocumentList({ data: res?.data?.data }));
              dispatch(
                setLoading({
                  key: "isCouponServiceListInProgress",
                  status: false,
                }),
              );
            } else {
              dispatch(
                setLoading({
                  key: "isCouponServiceListInProgress",
                  status: false,
                }),
              );
              dispatch(setDocumentList({ data: null }));
            }
          })
          .catch((e: AxiosError) => {
            dispatch(
              setLoading({
                key: "isCouponServiceListInProgress",
                status: false,
              }),
            );
            dispatch(setDocumentList({ data: null }));
            sendCurl(e.config["curlCommand"]);
            // captureError(e);
          });
      } catch (e: any) {
        dispatch(
          setLoading({
            key: "isCouponServiceListInProgress",
            status: false,
          }),
        );
        dispatch(setDocumentList({ data: null }));
      }
    },
    [dispatch],
  );
  return { execute };
};
